"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG = exports.TYPES = void 0;
var prefix = "@al/event-tracking/";
var tagPrefix = "".concat(prefix, "tag/");
exports.TYPES = {
    IBehaviorAdapterService: Symbol.for("".concat(prefix, "IBehaviorAdapterService")),
    IReportService: Symbol.for("".concat(prefix, "IReportService")),
    IApplicationExecutor: Symbol.for("".concat(prefix, "IApplicationExecutor")),
    IObservableService: Symbol.for("".concat(prefix, "IObservableService")),
    IObserver: Symbol.for("".concat(prefix, "IObserver")),
    IStorageService: Symbol.for("".concat(prefix, "IStorageService")),
    IEventObservable: Symbol.for("".concat(prefix, "IEventObservable")),
    IPipelineService: Symbol.for("".concat(prefix, "IPipelineService")),
    IPipelineTask: Symbol.for("".concat(prefix, "IPipelineTask")),
    IIntersectionService: Symbol.for("".concat(prefix, "IIntersectionService")),
    ISessionService: Symbol.for("".concat(prefix, "ISessionService")),
    IConfigService: Symbol.for("".concat(prefix, "IConfigService")),
    IRouteStackService: Symbol.for("".concat(prefix, "IRouteStackService")),
    IStoreService: Symbol.for("".concat(prefix, "IStoreService")),
    ITransformFieldsService: Symbol.for("".concat(prefix, "ITransformFieldsService")),
    IAdjustTimeService: Symbol.for("".concat(prefix, "IAdjustTimeService")),
    IActiveTabService: Symbol.for("".concat(prefix, "IActiveTabService")),
    IEventOrderBucket: Symbol.for("".concat(prefix, "EventOrderBucket")),
    ILeaveOpsService: Symbol.for("".concat(prefix, "ILeaveOpsService")),
    IExposeService: Symbol.for("".concat(prefix, "IExposeService")),
    IExposeDataManager: Symbol.for("".concat(prefix, "IExposeDataManager")),
};
exports.TAG = {
    ClickEventService: Symbol.for("".concat(tagPrefix, "ClickEventService")),
    InputEventService: Symbol.for("".concat(tagPrefix, "InputEventService")),
    PasteEventService: Symbol.for("".concat(tagPrefix, "PasteEventService")),
    UnloadEventService: Symbol.for("".concat(tagPrefix, "UnloadEventService")),
    VisibilityEventService: Symbol.for("".concat(tagPrefix, "VisibilityEventService")),
    LocalStoreService: Symbol.for("".concat(tagPrefix, "LocalStoreService")),
    SessionStoreService: Symbol.for("".concat(tagPrefix, "SessionStoreService")),
    VisibilityEventObserver: Symbol.for("".concat(tagPrefix, "VisibilityEventObserver")),
};
